<template>
	<div class="height-100dvh">
		<div
			class="mhp-main-header d-flex justify-content-between align-items-center"
		>
			<div>
				<img
					@click="$router.go(-1)"
					src="../../../assets/img/homepage/ms-header-arrow.svg"
					alt=""
					class="mr-2"
				/>
				Streaks
			</div>

			<div class="d-flex justify-content-between mb-0">
				<div>
					<img
						v-if="leftArrow"
						@click="arrowClick(streakData[0], 7)"
						class="pointer"
						src="../../../assets/img/homepage/hp-leftarrow.svg"
						alt=""
					/>

					<img
						v-if="rightArrow"
						@click="arrowClick(streakData[streakData.length - 1], 0)"
						class="hp-rightarrow pointer"
						src="../../../assets/img/homepage/hp-leftarrow.svg"
						alt=""
					/>
				</div>
			</div>
		</div>

		<div class="cand-mob-maincontainer p-3">
			<div class="mhp-main-container overflow-auto">
				<div
					class="hp-rgtcalender d-flex flex-wrap justify-content-around p-2 pl-3"
				>
					<div id="heatmap2" style="width: 100%" class="mt-3"></div>
				</div>

				<div
					v-if="streakData.length > 0"
					class="d-flex align-items-center mb-3 ml-5"
				>
					<div class="hp-activitytxt ml-4">Activity:</div>
					<div class="hp-endtxt ml-3 mr-2">Less</div>
					<div class="hp-whitesq ml-1"></div>
					<div class="hp-sqbox1 ml-1"></div>
					<div class="hp-sqbox2 ml-1"></div>
					<div class="hp-sqbox3 ml-1"></div>
					<div class="hp-sqbox4 ml-1"></div>

					<div class="hp-endtxt ml-2">More</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { vendorStat } from "vue-d3-charts-hire3x";
import { getCandStreak } from "../../../utils/apiFunctions.js";

export default {
	name: "mobStreaks",
	data() {
		return {
			streakData: [],
			leftArrow: false,
			rightArrow: false,
			startDate: "",
		};
	},
	async created() {
		this.startDate = await this.firstDate();
		this.getStreakGraph();
	},

	methods: {
		firstDate() {
			let today = new Date();
			// let today = new Date('2024 December 20, 69 00:20:18');
			let thisMonth;
			let thisYear;

			thisMonth = today.getMonth() + 2;
			thisYear = today.getFullYear();
			return this.getFiveMonthsBackDate(thisYear, thisMonth, 7);
		},
		getFiveMonthsBackDate(year, month, theMonth) {
			let date = new Date(year, month);
			date.setMonth(date.getMonth() - theMonth);
			// Get the new year and month
			let newYear = date.getFullYear();
			let newMonth = (date.getMonth() + 1).toString().padStart(2, "0");
			return `${newYear}-${newMonth}`;
		},
		arrowClick(myStreakData, getNum) {
			const num = getNum;
			this.startDate = this.getFiveMonthsBackDate(
				myStreakData.year,
				myStreakData.month,
				num
			);
			this.getStreakGraph();
		},

		async getStreakGraph() {
			this.streakData = [];
			setTimeout(() => {
				if (
					document.getElementById("heatmap2") &&
					document.getElementById("heatmap2").innerHTML != ""
				) {
					document.getElementById("heatmap2").innerHTML = "";
				}
			}, 100);

			try {
				// let payload;
				const resp = await getCandStreak(this.startDate);
				if (resp.status == 200) {
					this.streakData = resp.data.data.data;
					this.leftArrow = resp.data.data.prevPage;
					this.rightArrow = resp.data.data.nextPage;
					setTimeout(() => {
						if (
							document.getElementById("heatmap2") &&
							document.getElementById("heatmap2").innerHTML != ""
						) {
							document.getElementById("heatmap2").innerHTML = "";
						}
						const numOfCol = 2;
						const cellSize = 28;
						const height = 28;
						const vendorDataChart = new vendorStat();
						vendorDataChart.heatmaps(
							this.streakData,
							numOfCol,
							cellSize,
							height
						);
					}, 200);
				} else {
					console.log("APi Error");
				}
			} catch (error) {
				console.log(error);
			}
		},
	},
};
</script>
<style>
.mhp-main-header {
	padding-top: env(safe-area-inset-top) !important;
	height: calc(60px + env(safe-area-inset-top));
	width: 100%;
	padding: 12px 15px 14px 16px;
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}

.cand-mob-maincontainer {
	position: relative;
	background: var(--bg-lightblueback);
	height: calc(100dvh - (60px + env(safe-area-inset-top)));
	overflow-x: hidden;
	padding: 15px 15px 15px 75px;
}

.mhp-main-container {
	width: 100%;
	height: 100%;
	background: #ffffff;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}

.gap-10 {
	gap: 10px;
}

.hp-monthtxt {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #3a3c40;
	text-align: center;
}

.mhp-calender-img {
	width: 131px;
	height: 131px;
}

.hp-activitytxt {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 11px;
	color: #333333;
}

.hp-endtxt {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 11px;
	color: #333333;
}

.hp-rightarrow {
	top: 77px;
	transform: rotate(-180deg);
	right: 6px;
}

.hp-whitesq {
	width: 12px;
	height: 12px;
	background: #f5f5f5;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	transform: matrix(-1, 0, 0, 1, 0, 0);
}

.hp-sqbox1 {
	width: 12px;
	height: 12px;
	background: #a6cbc5;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	transform: matrix(-1, 0, 0, 1, 0, 0);
}

.hp-sqbox2 {
	width: 12px;
	height: 12px;
	background: #68b4a9;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	transform: matrix(-1, 0, 0, 1, 0, 0);
}

.hp-sqbox3 {
	width: 12px;
	height: 12px;
	background: #44a798;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	transform: matrix(-1, 0, 0, 1, 0, 0);
}

.hp-sqbox4 {
	width: 12px;
	height: 12px;
	background: #289d8b;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	transform: matrix(-1, 0, 0, 1, 0, 0);
}
</style>
